import React from 'react';

const RISK_SVG_MAP = {
  1: ({ img }) => (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 30C24.5666 30 31 23.6744 31 16C31 8.32558 24.5666 2 16.5 2C8.43341 2 2 8.32558 2 16C2 23.6744 8.43341 30 16.5 30ZM16.5 32C25.6127 32 33 24.8366 33 16C33 7.16344 25.6127 0 16.5 0C7.3873 0 0 7.16344 0 16C0 24.8366 7.3873 32 16.5 32Z"
        fill="#389E0D"
      />
      {img && (
        <image
          href={img}
          x="8"
          y="8"
          width="17"
          height="16"
          preserveAspectRatio="xMidYMid meet"
        />
      )}
    </svg>
  ),
  2: ({ img }) => (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5 2H16.5C8.76801 2 2.5 8.26801 2.5 16C2.5 23.732 8.76801 30 16.5 30C24.232 30 30.5 23.732 30.5 16V2ZM16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32C25.3366 32 32.5 24.8366 32.5 16V0H16.5Z"
        fill="#389E0D"
      />
      {img && (
        <image
          href={img}
          x="8"
          y="6"
          width="17"
          height="20"
          preserveAspectRatio="xMidYMid meet"
        />
      )}
    </svg>
  ),
  3: ({ img }) => (
    <svg
      width="41"
      height="32"
      viewBox="0 0 41 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 32L0.5 0H40.5L20.5 32ZM20.5 28.2425L4.11009 2.01863H36.8899L20.5 28.2425Z"
        fill="#FFC069"
      />
      {img && (
        <image
          href={img}
          x="10"
          y="3"
          width="20"
          height="16"
          preserveAspectRatio="xMidYMid meet"
        />
      )}
    </svg>
  ),
  4: ({ img }) => (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 2.7859L2.87296 16L16.5 29.2141L30.127 16L16.5 2.7859ZM16.5 0L0 16L16.5 32L33 16L16.5 0Z"
        fill="#CF1322"
      />
      {img && (
        <image
          href={img}
          x="8"
          y="8"
          width="17"
          height="16"
          preserveAspectRatio="xMidYMid meet"
        />
      )}
    </svg>
  ),
  5: ({ img }) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.16478L6.21703 6.21703L2.16478 16L6.21703 25.783L16 29.8352L25.783 25.783L29.8352 16L25.783 6.21703L16 2.16478ZM27.3137 4.68629L16 0L4.68629 4.68629L0 16L4.68629 27.3137L16 32L27.3137 27.3137L32 16L27.3137 4.68629Z"
        fill="#FF4D4F"
      />
      {img && (
        <image
          href={img}
          x="6"
          y="6"
          width="20"
          height="20"
          preserveAspectRatio="xMidYMid meet"
        />
      )}
    </svg>
  ),
};

const RiskSymbolDisplay = ({ symbolData, size = 'md' }) => {
  const getLevelFromLabel = (label) => {
    if (!label) return 1;
    const l = label.toLowerCase();
    if (l.includes('faible')) return 1;
    if (l.includes('leger')) return 2;
    if (l.includes('modere')) return 3;
    if (l.includes('eleve') && !l.includes('tres')) return 4;
    if (l.includes('tres') || l.includes('extremely')) return 5;
    return 1;
  };

  const getSymbolInfo = () => {
    if (typeof symbolData === 'number')
      return { value: symbolData, image: null, label: null };
    if (symbolData?.symbol || symbolData?.calculated_value) {
      return {
        value:
          symbolData.calculated_value ||
          getLevelFromLabel(symbolData.symbol?.label),
        image: symbolData.symbol?.image,
        label: symbolData.symbol?.label,
      };
    }
    return null;
  };

  const symbolInfo = getSymbolInfo();
  if (!symbolInfo) return <div>N/A</div>;

  const sizeMap = { sm: 32, md: 48, lg: 64 };
  const svgSize = sizeMap[size] || sizeMap.md;

  const SvgComponent = RISK_SVG_MAP[symbolInfo.value] || RISK_SVG_MAP[1];

  return (
    <div
      className="flex justify-center items-center"
      style={{ width: svgSize, height: svgSize }}
    >
      {SvgComponent({ img: symbolInfo.image })}
    </div>
  );
};

export default RiskSymbolDisplay;
